// logic-check-popup.js - Anzeige der Logikpruefung (UltraThink) im Split-Popup

/**
 * Show logic check results in a popup panel
 */
export function showLogicCheckPopup(result) {
  const popup = document.getElementById('logic-check-popup');
  const content = document.getElementById('logic-check-popup-content');
  const editorPanel = document.getElementById('markdown-editor');

  if (!popup || !content) return;

  // Build content HTML - only show analysis (which already contains errors)
  let html = '';

  // Show analysis (contains both analysis and errors sections)
  html += '<div class="logic-check-analysis">' + escapeHtml(result.analysis) + '</div>';

  content.innerHTML = html;
  popup.classList.add('visible');

  // Add split-screen class to editor panel
  if (editorPanel) {
    editorPanel.classList.add('split-with-logic-check');
  }
}

/**
 * Escape HTML to prevent XSS
 */
function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
